<template>
  <div>
    <operations-detail-component-global 
      :sApiGetOC="sApiGetOC" 
      :aHeadersRawMaterials="aHeadersRawMaterials"
      :sTypeItem="4" 
      sBackHref="ProviderDetail" 
      sTextDetail="" 
      setDialog="setDialogConfirmationOfPaid" 
      sTextBtnAdd=""
      :bAdminPermissions="false" 
      :itemsBreadcrumbs="itemsBreadcrumbs" 
      :toProvider="toProvider" 
      :bToProvider="false" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemsBreadcrumbs: [],
      toProvider: "",
      sApiGetOC: "",
      aHeadersRawMaterials: [
        {
          text: "#",
          sortable: false,
          value: "dNumTransation",
          class: "global-header-table",
          cellClass: "global-body-table ",
        },
        {
          text: "Código",
          sortable: false,
          value: "sCodeRawMaterial",
          class: "global-header-table",
          cellClass: "global-body-table ",
        },
        {
          text: "Nombre de la materia",
          sortable: false,
          value: "sNameRawMaterial",
          class: "global-header-table",
          cellClass: "global-body-table ",
        },
        {
          text: "Peso",
          sortable: false,
          value: "dWeightRawMaterial",
          class: "global-header-table",
          cellClass: "global-body-table ",
        },
        // {
        //   text: "Precio unitario",
        //   sortable: false,
        //   value: "dUnitPriceRawMaterial",
        //   class: "global-header-table",
        //   cellClass: "global-body-table ",
        // },
        // {
        //   text: "Subtotal",
        //   sortable: false,
        //   value: "dSubtotalRawMaterial",
        //   class: "global-header-table",
        //   cellClass: "global-body-table ",
        // },
        {
          text: "Nombre del responsable",
          sortable: false,
          value: "sManagerRawMaterial",
          class: "global-header-table",
          cellClass: "global-body-table ",
        },
        {
          text: "Acciones",
          value: "accions",
          align: "center",
          class:
            "global-header-table global-header-accions global-col-header-accion",
          cellClass:
            "global-body-table global-body-accions global-col-body-accion",
        },
      ],
    };
  },
  beforeMount() {
    this.setNameBreadcrumbs();
    this.setApiGetOC();
  },
  methods: {
    setNameBreadcrumbs() {
      let aBreadcrumbs = [
        {
          text: "Proveedores",
          disabled: false,
          to: { name: "Provider" },
        },
        {
          text: `Detalle de una ${this.sTabProviderOrPerson === 0 ? ' empresa' : ' persona fisica'}`,
          link: true,
          exact: true,
          disabled: false,
          to: { name: "ProviderDetail" },
          params: { id: this.$route.params.idOP },
        },
        {
          text: "Detalle de un pedido",
          disabled: true,
          to: { name: "" },
        },
      ];
      this.itemsBreadcrumbs = aBreadcrumbs;
      this.toProvider = `/home/provider-detail/${this.$route.params.id}/op-detail-provider/${this.$route.params.idOP}/user-profile-detail-provider`;
    },
    setApiGetOC() {
      this.sApiGetOC = `${URI}/api/sp/v1/orders/general/`;
    },
  },
  computed: {
    sTabProviderOrPerson() {
      return this.$store.state.sTabPosition;
    },
  },
};
</script>

<style>
</style>